
import { mapGetters, mapActions } from 'vuex';

// LIBRARIES
import { getPlaceNameWithPreposition } from '../libraries/utils';

export default {
  name: 'SResultTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    geo: {
      type: Boolean,
      default: false,
    },
    short: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggleViewMode: true,
    };
  },
  computed: {
    ...mapGetters({
      getViewMode: 'preferences/getViewMode',
    }),
    longTitle() {
      if (!this.title) {
        return null;
      }
      const [preposition, placeName] = getPlaceNameWithPreposition(this.title).split(/\s+(.*)/);
      return { preposition, placeName };
    },
  },
  mounted() {
    this.toggleViewMode = this.getViewMode === 'list';
  },
  methods: {
    ...mapActions({
      updateViewMode: 'preferences/updateViewMode',
    }),
    changeViewMode() {
      const view = this.getViewMode === 'list' ? 'map' : 'list';
      this.updateViewMode(view);
      if (this.$matomo) {
        this.$matomo.trackEvent('ViewMode', 'toggleView', view);
      }
    },
  },
};
